/*
 * @Author: zengsheng 12181283
 * @Date: 2025-11-19 09:17:56
 * @LastEditors: zengsheng 12181283
 * @LastEditTime: 2025-11-19 10:53:37
 * @FilePath: \itoss_frontend\src\App.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { Component } from 'react';
import { Provider } from 'react-redux';

// 封装 LocaleProvider Redux 和 IntlProvider Redux
import LocaleProvider from './app/store/LocaleProvider';
import { addLocaleData } from 'react-intl';
import { IntlProvider, updateIntl } from 'react-intl-redux';

//这里最好是用hashHistory.这样build出来的整个项目放在tomcat等其他服务器下也可以运行。
//如果使用browserHistory的话，放tomcat下会有路由处理的问题。
// import { Router, browserHistory, hashHistory } from 'react-router-dom';
import {BrowserRouter ,HashRouter} from 'react-router-dom'
import AppRoutes from './app-route';
// import "@icon-park/react/styles/index.css"
import "./scss/screen.scss";

import configureStore from './app/store/configureStore';
var store = configureStore();
import Store from './app/script/store';

// 添加 locale 数据
import appLocale_en from './entry/en-US';
import appLocale_zh from './entry/zh-CN';
// addLocaleData([...appLocale_zh.data, ...appLocale_en.data]);
let appLocale = {
  'en': appLocale_en,
  "zh-CN": appLocale_zh
};
// default locale
if(!Store.get('Language')){
  Store.set('Language','zh-CN');
}
var defaultLocale = Store.get('Language') || 'zh-CN';// 'en',"zh-CN";

class App extends Component {

  componentWillMount() {
    store.dispatch({
      type: 'UPDATE_LOCALES',
      payload: appLocale
    })
    store.dispatch(updateIntl({
      locale: defaultLocale,
      messages: appLocale[defaultLocale] ? appLocale[defaultLocale].messages : appLocale['en'].messages
    }))
  }

  render() {
    // Store.set('token','0AEA074BAEE54967855FE25C0D0B411D')
    return (
      <Provider store={store}>
        <IntlProvider>
          <LocaleProvider>
            <HashRouter>
              {AppRoutes}
            </HashRouter>
          </LocaleProvider>
        </IntlProvider>
      </Provider>
    )
  }
}

export default App;
